// Label 1 → trigger first thumbnail
function simulateFullUserClick(element) {
  if (!element) return;

  const eventOptions = { view: window, bubbles: true, cancelable: true };

  element.dispatchEvent(new MouseEvent('mousedown', eventOptions));
  element.dispatchEvent(new MouseEvent('mouseup', eventOptions));
  element.dispatchEvent(new MouseEvent('click', eventOptions));
}

$(document).on("click", ".inp-prod-input-fo label", function () {
  const colorName = $(this).attr('title').trim();  // Extract color from label's title

  const targetImg = Array.from(document.querySelectorAll('.pf-slide-list-media img')).find(img => {
    return img.getAttribute('alt').trim().toLowerCase() === colorName.toLowerCase();
  });

  if (targetImg) {
    const mediaElement = targetImg.closest('.pf-slide-list-media');

    // Simulate the click on thumbnail
    simulateFullUserClick(mediaElement);

    /** ========== THUMBNAIL SLIDER ========== **/
    document.querySelectorAll('.pf-slide-list-media').forEach(el => {
      el.classList.remove('active-sibling', 'inactive-sibling');
    });

    const thumbSiblings = Array.from(mediaElement.parentElement.children);
    thumbSiblings.forEach(sib => {
      const img = sib.querySelector('img');
      if (!img) return;
      const altText = img.getAttribute('alt')?.trim().toLowerCase();

      if (altText === colorName.toLowerCase()) {
        sib.classList.add('active-sibling');
      } else {
        sib.classList.add('inactive-sibling');
      }
    });

    /** ========== MAIN SLIDER ========== **/
    const mainSlides = document.querySelectorAll('.pf-slide-main-media');
    mainSlides.forEach(slide => {
      slide.classList.remove('active-sibling', 'inactive-sibling');
      const img = slide.querySelector('img');
      if (!img) return;
      const altText = img.getAttribute('alt')?.trim().toLowerCase();

      if (altText === colorName.toLowerCase()) {
        slide.classList.add('active-sibling');
      } else {
        slide.classList.add('inactive-sibling');
      }
    });

  } else {
    console.warn(`No matching image found for color: ${colorName}`);
  }
});
function triggerFirstColorOnceAvailable() {
  const interval = setInterval(() => {
    const firstLabel = document.querySelector('.inp-prod-input-fo label');
    if (firstLabel) {
      firstLabel.click();
      clearInterval(interval);
    }
  }, 3000);  // Check every 3s
}

$(document).ready(function() {
  triggerFirstColorOnceAvailable();
});

function observeActiveSlideAndSyncThumbnail() {
  const slider = document.querySelector(".pf-media-slider");
  const slides = slider?.querySelectorAll(".pf-slide-main-media");
  if (!slider || !slides.length) return;

  // Reuse observer only once
  if (window._activeSlideObserver) return;

  let currentMediaId = null;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
        const mediaId = entry.target.getAttribute("data-media-id");
        if (!mediaId || mediaId === currentMediaId) return;

        currentMediaId = mediaId;

        // Remove previous data-active
        document.querySelectorAll(".pf-slide-list-media[data-img-id]").forEach(el => {
          el.removeAttribute("data-active");
        });

        // Set new active thumbnail
        const thumb = document.querySelector(`.pf-slide-list-media[data-img-id="${mediaId}"]`);
        if (thumb) {
          thumb.setAttribute("data-active", "true");
        }
      }
    });
  }, {
    root: slider,
    threshold: 0.8,
  });

  slides.forEach(slide => observer.observe(slide));

  // Save reference so it's not recreated
  window._activeSlideObserver = observer;
}

function continuouslySyncActiveThumbnail() {
  setInterval(() => {
    const visibleSlide = document.querySelector('.pf-slide-main-media.is-visible');

    if (!visibleSlide) return;

    const mediaId = visibleSlide.getAttribute('data-media-id');
    if (!mediaId) return;

    const thumbnails = document.querySelectorAll('.pf-slide-list-media[data-img-id]');
    thumbnails.forEach(el => {
      const isMatch = el.getAttribute('data-img-id') === mediaId;
      if (isMatch) {
        el.setAttribute('data-active', 'true');
      } else {
        el.removeAttribute('data-active');
      }
    });
  }, 500); // Sync every 500ms
}

window.addEventListener("load", () => {
  continuouslySyncActiveThumbnail();
});


let sliderTransitionLock = false;

function sliderResetCompatabilityFix() {
  if (sliderTransitionLock) return;
  sliderTransitionLock = true;

  requestAnimationFrame(() => {
    const allChildren = document.querySelectorAll(".main-gallery  .pf-list-media div *");

    const firstVisibleChild = Array.from(allChildren).find((element) => {
      const rect = element.getBoundingClientRect();
      const parentRect = element.parentElement.getBoundingClientRect();
      return rect.left >= parentRect.left && rect.right <= parentRect.right;
    });

    if (!firstVisibleChild) {
      sliderTransitionLock = false;
      return;
    }

    const imgId = firstVisibleChild.getAttribute("data-img-id");
    const mediaSlider = document.querySelector(".main-gallery  .pf-media-slider");

    if (!mediaSlider || !mediaSlider.SnapSlider) {
      sliderTransitionLock = false;
      return;
    }

    const children = Array.from(mediaSlider.children);

    const targetIndex = children.findIndex(
      (child) => child.getAttribute("data-media-id") === imgId
    );

    if (targetIndex !== -1) {
      mediaSlider.SnapSlider.goto(targetIndex + 1, {
        force: true,
        immediate: true,
      });


      // Optional: mark it active
      setTimeout(() => {
       // document.querySelectorAll(".pf-list-media [data-active]").forEach(el => el.removeAttribute("data-active"));
        firstVisibleChild.setAttribute("data-active", "true");
        sliderTransitionLock = false;
      }, 5000);
    } else {
      sliderTransitionLock = false;
    }
  });
}






// Fixes Patchumz collection A-B-C patches hover image
function patchumzABCHoverFix() {
  document
    .querySelectorAll('[data-media-id="29210482180268"]')
    .forEach((element) => {
      const slider = element ? element.parentElement : null;
      if (!slider) return;
      const slides = slider.querySelectorAll(".main-gallery  .pf-slide-main-media");
      const secondImageUrl =
        "//www.happygear.com/cdn/shop/files/Large_Letters_1.webp"; // Replace with the actual URL of secondImage

      if (slides.length < 2) return; // Skip if there are fewer than 2 slides

      const secondImgElement = slides[1].querySelector("img");

      if (!secondImgElement || secondImgElement.src.includes(secondImageUrl)) {
        // Skip if the second image is already the secondImage URL
        return;
      }

      let previousImage = secondImgElement.src;

      for (let i = 2; i < slides.length; i++) {
        console.log("Checking slide " + i);
        const currentImgElement = slides[i].querySelector("img");
        if (!currentImgElement) continue;

        if (!currentImgElement.src.includes(secondImageUrl)) {
          console.log("Swapping images");
          const tempSrc = currentImgElement.src;
          currentImgElement.src = previousImage;
          previousImage = tempSrc;
        } else {
          console.log(
            "Found the second image, swapping and replacing 2nd slide with 2nd image"
          );
          // If the current image is the secondImageUrl, replace it with the previous image and stop
          currentImgElement.src = previousImage;
          slides[1].querySelector("img").src =
            "//www.happygear.com/cdn/shop/files/Large_Letters_1.webp?v=1714560295";
          break;
        }
      }
    });
}
function handleVariantImages(evt) {
  if ( evt.srcElement.id ) {
    //var colorRegex = evt.srcElement.id.match(/-Color-(\w+)-/);
    var colorRegex = evt.srcElement.id.match(/Color-([A-Za-z-]+)-(\d{4,})/);
    var letterRegex = evt.srcElement.id.match(/-Letter-(\w+)-/);
    
    document.querySelectorAll(".main-gallery .pf-media-slider").forEach((pfMediaSlider) => {
      if (colorRegex != null) {
        const wordToSearch = colorRegex[1].replace(/-/g, ' ');
        pfMediaSlider.querySelectorAll("[alt]").forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "none"; // Update this line to the desired style
          }
        });
        const thumbnailSelector = `[alt = '${wordToSearch}']`;
        pfMediaSlider.querySelectorAll(thumbnailSelector).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
        pfMediaSlider.querySelectorAll(`[alt = 'All']`).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
      }
      if (letterRegex != null) {
        pfMediaSlider.querySelectorAll("[alt]").forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "none"; // Update this line to the desired style
          }
        });
        const thumbnailSelector = `[alt = '${letterRegex[1]}']`;
        pfMediaSlider.querySelectorAll(thumbnailSelector).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
        pfMediaSlider.querySelectorAll(`[alt = 'All']`).forEach((img) => {
          if (img.parentElement) {
            img.parentElement.style.display = "block"; // Update this line to the desired style
          }
        });
      }
    });

    // Reset variant image to first in carousel
    setTimeout(function () {
      sliderResetCompatabilityFix();
    }, 200);
  }
}

// Add badge with Standard, Mini or Large Pachumz
function addBadges() {
  if (document.body.id == "shop-all-patchumz") {
    Array.from(document.querySelectorAll(".pf-product-form")).forEach((e) => {
      const regex = /\b(\w+)\s+Patchumz\b/;

      // Extract the word before "Patchumz"
      const match = regex.exec(e.innerText);

      if (
        match != null &&
        match != undefined &&
        match[1] != null &&
        match[1] != undefined
      ) {
        const badge = document.createElement("p");
        badge.innerText = match[1];
        badge.classList.add("pf-badge-patchumz");
        e.appendChild(badge);
      }
    });
  }
}

function handleClick() {
  console.log("handleClick");

  const elements = document.querySelectorAll(".main-gallery  .pf-slide-list-media");

  elements.forEach((e) => {
    e.style.cssText;
    if (e.style.cssText == "display: block;") {
      e.click();
    } else {
      console.log("The element does not have display: block style.");
    }
  });
}

function handleClickUnlock() {
  sliderTransitionLock = false;
}

function handleChangeVariant() {
  const variants = document.querySelectorAll("[data-option-name = 'Color']");

  variants.forEach((element) => {
    element.addEventListener("click", handleClick);
  });
}

document.addEventListener("change", function (evt) {
  handleVariantImages(evt);
});

document.addEventListener("load", function (evt) {
  handleVariantImages(evt);
});

document.addEventListener("DOMContentLoaded", function (evt) {
  try {
    addBadges();
  } catch (e) {
    console.log(e);
  }
  try {
    handleChangeVariant();
  } catch (e) {
    console.log(e);
  }
  try {
    createSliderNavigation(".template-product");
   
  } catch (e) {
    console.log(e);
  }

  try {
    changeQuickViewButtonBehavior();
    handleVariantImages(evt);
  } catch (e) {
    console.log(e);
  }
  try {
    patchumzABCHoverFix();
  } catch (e) {
    console.log(e);
  }

  try {
    let checked = document.querySelector(
      "[data-option-name = 'Color'] input[type='radio']:checked"
    );
    if (!checked){
      checked = document.querySelector(
          "[data-option-name = 'Letter'] input[type='radio']:checked"
      );
    }
    if (!checked) return;
    handleVariantImages({
      srcElement: {
        id: checked.id,
      },
    });
  } catch (e) {
    console.log(e);
  }

    const mediaList  = document.querySelectorAll(".main-gallery  .pf-list-media div div");
    mediaList.forEach((media) => {
        media.addEventListener("click", function (event) {
            // Prevent the default behavior of the link
          handleClickUnlock();
        });
    });
});

function changeQuickViewButtonBehavior(quickAddButton) {
  var quickAddButton = document.querySelectorAll(
    `[data-product-id="7849162801324"]`
  )[4];
  if (
    quickAddButton == undefined ||
    quickAddButton.getAttribute("type") != "button"
  )
    return;
  quickAddButton.removeAttribute("data-checkout");
  quickAddButton.removeAttribute("name");
  quickAddButton.removeAttribute("type");
  quickAddButton.removeAttribute("data-pf-type");
  quickAddButton.style.display = "block";

  quickAddButton.addEventListener("click", function (event) {
    // Prevent the default behavior of the link
    event.preventDefault();
  });

  // Create a new anchor element
  var quickAddLink = document.createElement("a");

  // Copy attributes from button to anchor
  Array.from(quickAddButton.attributes).forEach(function (attr) {
    quickAddLink.setAttribute(attr.name, attr.value);
  });

  // Set href attribute for the anchor (assuming '#' for now)
  quickAddLink.setAttribute("href", "/products/premium-letters-patchumz");

  // Set inner text of the anchor
  quickAddLink.innerText = "Select Letter";

  // Replace the button element with the anchor element
  quickAddButton.parentNode.replaceChild(quickAddLink, quickAddButton);
}

// Slider navigation
function createSliderNavigation(pageId) {
  const content = document.querySelector(`${pageId} .main-gallery  .pf-media-slider`);
  if (!content) return;

  // Create the buttons
  const prevButton = document.createElement("a");
  prevButton.setAttribute("type", "button");
  prevButton.className = "pf-slider-prev pf-slider-prev--special";

  const nextButton = document.createElement("a");
  nextButton.setAttribute("type", "button");
  nextButton.className = "pf-slider-next pf-slider-next--special";

  // Scroll behavior
  prevButton.addEventListener("click", () => {
    content.scrollLeft -= 500;
    updateButtonVisibility();
  });

  nextButton.addEventListener("click", () => {
    content.scrollLeft += 500;
    updateButtonVisibility();
  });

  content.appendChild(prevButton);
  content.appendChild(nextButton);

  // Call it once to set initial state
  updateButtonVisibility();

  // Update buttons on scroll
  content.addEventListener("scroll", updateButtonVisibility);

  function updateButtonVisibility() {
    const maxScroll = content.scrollWidth - content.clientWidth;
    prevButton.style.display = content.scrollLeft <= 10 ? "none" : "block";
    nextButton.style.display = content.scrollLeft >= maxScroll - 10 ? "none" : "block";
  }
}


// Change
function removeSlideNavigationsOnBorders(pageId) {
  const elements = document.querySelectorAll(`${pageId} .main-gallery  .pf-slide-main-media`);

  if (elements == undefined || elements.length == 0) return;

  const prevButton = document.getElementsByClassName(
    "pf-slider-prev--special"
  )[0];
  const nextButton = document.getElementsByClassName(
    "pf-slider-next--special"
  )[0];

  // Create a new MutationObserver
  const observerFirst = new MutationObserver((mutationsList) => {
    // Check each mutation for changes to class list
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        elements.forEach((e) => {
          var processedElement = Array.from(
            Array.from(elements).find((e) => e.style.display != "none")
              .classList
          );
          if (
            processedElement[1] == "is-visible" ||
            processedElement[1] == "is-current"
          ) {
            prevButton.style.display = "none";
          } else {
            prevButton.style.display = "block";
          }
        });
      }
    });
  });

  const observerLast = new MutationObserver((mutationsList) => {
    // Check each mutation for changes to class list
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        if (
          elements[elements.length - 1].classList.value.includes("is-visible")
        ) {
          nextButton.style.display = "none";
        } else {
          nextButton.style.display = "block";
        }
      }
    });
  });

  // Define the configuration for the observer (we want to monitor attributes)
  const config = { attributes: true };
  observerFirst.observe(elements[0], config);
  observerLast.observe(elements[elements.length - 1], config);
}// Start observing the target node for configured mutations

window.onload = function() {

  // Define the specific product handle you want to target
  const targetProductHandle = 'mini-letters'; // replace with the handle of the specific product

  // Check if the current URL matches the target product handle

    // Define a target element that only appears after PageFly finishes loading
    const targetSelector = '.pf-option-swatches'; // Replace with a unique selector in your PageFly content

    // Function to execute your custom JavaScript
    function executeAfterPageFlyLoad() {
      const variantBox = document.querySelector('.pf-option-swatches');

      if (window.location.pathname.includes(`/products/${targetProductHandle}`)) {
      const oldElement = variantBox.querySelector('input[type="radio"][value="100"]');

      if (oldElement) {
        // You now have the input element with value "100"
        const parentOldElement = oldElement.closest('div[data-option-name="Letter"].pf-vs-color.pf-vs-square');
        parentOldElement.style.display = 'none';
      }

      const heartElement = variantBox.querySelector('input[type="radio"][value="Heart"]');

      if (heartElement) {
        // You now have the input element with value "100"
        const parentHeartElement = heartElement.closest('div[data-option-name="Letter"].pf-vs-color.pf-vs-square');

        const heartLabelSpan = parentHeartElement.querySelector('label[for="' + heartElement.id + '"] span');

        if (heartLabelSpan) {
          // Replace the text content with the heart symbol
          heartLabelSpan.innerHTML = '&#10084;';
        }
      }

      };

      const parentElement = variantBox.closest('div[data-display="dropdown"][data-product-id][class*="sc-frelQW"][class*="pf-34_"]');
      if ( parentElement ) {
        parentElement.style.display = 'block';
      }
    }

    // Observe the document for PageFly element loading
    const observer = new MutationObserver((mutations, observer) => {
      if (document.querySelector(targetSelector)) {
        executeAfterPageFlyLoad();
        observer.disconnect();
      }
    });

    // Start observing the body for changes
    observer.observe(document.body, { childList: true, subtree: true });
  
};


//document.addEventListener('DOMContentLoaded', updateSliderNavVisibility);
//# sourceMappingURL=/cdn/shop/t/34/assets/custom.js.map?v=94411045917460764551733324370

$(document).ready(function(){
 $(".js-menu-drawer-trigger").click(function(){
   $(".js-menu-drawer").toggleClass("active");
   $("body").toggleClass("o-hidden")
 })
})


document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll('.faq-button')
    var arrayElements = Array.from(elements);
    
    arrayElements.forEach(function(element) {
        var img = document.createElement('img');
        img.classList.add('pf-faq-icon');
        switch(element.children[0].innerText) {
             case 'Ordering &\nShipping':
                  img.src = 'https://cdn.shopify.com/s/files/1/0956/8465/7491/files/faq-order.svg?v=1749003000';
                  return element.insertBefore(img, element.firstChild);
            case 'Returns &\nExchanges':
                  img.src = 'https://cdn.shopify.com/s/files/1/0261/5404/1406/files/Icon_Returns_84aa7046-b0a5-476d-97f8-d4082feba158.svg';
                  return element.insertBefore(img, element.firstChild);
            case 'Gear':
                  img.src = 'https://cdn.shopify.com/s/files/1/0956/8465/7491/files/faq-gear.svg?v=1749002784';
                  return element.insertBefore(img, element.firstChild);
            case 'Patchumz®':
                  img.src = 'https://cdn.shopify.com/s/files/1/0956/8465/7491/files/faq-patchumz.svg?v=1749002845';
                  return element.insertBefore(img, element.firstChild);
            case 'Happiness\nGuarantee':
                  img.src = 'https://cdn.shopify.com/s/files/1/0956/8465/7491/files/faq-happines.svg?v=1749002936';
                  return element.insertBefore(img, element.firstChild);
            default:
                  img.src = 'https://cdn.shopify.com/s/files/1/0261/5404/1406/files/features.svg';
                  return element.insertBefore(img, element.firstChild);
        }
    });
});




$(document).ready(function () {
  function updateLabel(type, labelText, valueClass, extraHTML = '') {
    var selectedValue = $('.pf-option-swatches[data-swatch-type="' + type + '"] input[type="radio"]:checked').val();

    $('.pf-variant-label').each(function () {
      if ($(this).text().trim().startsWith(labelText)) {
        // Ensure span exists, else add it
        if ($(this).find('.' + valueClass).length === 0) {
          $(this).html(labelText + ': <span class="' + valueClass + '"></span>' + extraHTML);
        }
        $(this).find('.' + valueClass).text(selectedValue || '');
      }
    });
  }
  // Initial load
  updateLabel('label', 'Letter', 'pf-value-letter');
  updateLabel('color', 'Color', 'pf-value-color');

  // For Size, include Size Guide HTML
  updateLabel(
    'label',
    'Size',
    'pf-value-size',
    ' <strong class="size-guide-link"><img src="https://cdn.shopify.com/s/files/1/0956/8465/7491/files/Size_Guide.svg?v=1748037784">Size Guide</strong>'
  );

  // Event listeners
  $('.pf-option-swatches[data-swatch-type="label"] input[type="radio"]').on('change', function () {
    updateLabel('label', 'Letter', 'pf-value-letter');
    updateLabel(
      'label',
      'Size',
      'pf-value-size',
      ' <strong class="size-guide-link"><img src="https://cdn.shopify.com/s/files/1/0956/8465/7491/files/Size_Guide.svg?v=1748037784">Size Guide</strong>'
    );
  });

  $('.pf-option-swatches[data-swatch-type="color"] input[type="radio"]').on('change', function () {
    updateLabel('color', 'Color', 'pf-value-color');
  });
$('#bundles .product-card .card__heading').each(function () {
    var text = $(this).html();
    var updatedText = text.replace(/with\s+/i, 'with<br>');
    $(this).html(updatedText);
  });
});

(function () {
  const TIMEOUT = 5000;

  function extendCartNotificationTimeout(timeout = TIMEOUT) {
    const cartNoti = document.querySelector('sht-cart-noti');
    if (
      cartNoti &&
      typeof cartNoti.clearDismissTimeout === 'function' &&
      typeof cartNoti.close === 'function'
    ) {
      cartNoti.clearDismissTimeout();

      cartNoti.dismiss_timeout = setTimeout(() => {
        cartNoti.close();
      }, timeout);
    }
  }

  function overrideCartNotificationSetTimeout(timeout = TIMEOUT) {
    const cartNoti = document.querySelector('sht-cart-noti');

    if (
      cartNoti &&
      typeof cartNoti.setDismissTimeout === 'function'
    ) {
      const originalSetDismissTimeout = cartNoti.setDismissTimeout.bind(cartNoti);

      cartNoti.setDismissTimeout = function () {
        this.clearDismissTimeout?.();
        this.dismiss_timeout = setTimeout(() => {
          this.close();
        }, timeout);

        if (this.elms?.sticky_header?.dataset?.isEnabled === "false") {
          setTimeout(() => {
            this.elms.sticky_header.reset();
          }, timeout + 1000);
        }
      };

      // Immediately apply it if cart is currently visible
      if (cartNoti.hasAttribute('open')) {
        cartNoti.setDismissTimeout();
      }
    }
  }

  // Watch for cart-noti being opened or replaced
  const observer = new MutationObserver(() => {
    overrideCartNotificationSetTimeout();
  });

  const observeCart = () => {
    const cartNoti = document.querySelector('sht-cart-noti');
    if (cartNoti) {
      observer.observe(cartNoti, { attributes: true, attributeFilter: ['open'] });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    observeCart();
    overrideCartNotificationSetTimeout();
  });

  // Re-run when new cart-noti appears in DOM
  const cartInitObserver = new MutationObserver(() => {
    observeCart();
    overrideCartNotificationSetTimeout();
  });

  cartInitObserver.observe(document.body, { childList: true, subtree: true });

  // Optional: expose manual function
  window.extendCartNotificationTimeout = extendCartNotificationTimeout;
})();


